import MemoryMap from 'nrf-intel-hex';


export default function generateHex(userSettings) {

    let memoryMap = new MemoryMap();
    let binarySettings = new Uint8Array([
        ...sensRoleBinary(),
        ...measTimesBinary(userSettings.measTimes),
        ...measIntervalBinary(userSettings.measInterval),
        ...measTypeBinary(userSettings.measType),
        ...temp_thresholdBinary(userSettings.temp_threshold),
        ...scan_intervalBinary(),
        ...magnetOnBinary(),
        ...accDetectTypeBinary(userSettings.accDetectType),
        ...accSensitivityBinary(userSettings.acc_sensitivity),
        ...accMovementBinary(userSettings.acc_movement),
        ...otaaBinary(userSettings.otaa),
        ...loraSubbandBinary(userSettings.lora_subband, userSettings.lora_region),
        ...loraRegionBinary(userSettings.lora_region),
        ...tilt_axisBinary(),
        ...tx_radioBinary(userSettings.tx_radio),
        ...gatewayIPBinary(userSettings.gatewayIP),
        ...slaves_addrBinary(),
        ...NBIOT_operatorBinary(userSettings.NBIOT_operator),
        ...nbiot_apnBinary(userSettings.nbiot_apn),
        ...us_calibrated_thresholdBinary(),
        ...loraConfirmedMsgTimeThresholdBinary(userSettings.loraConfirmedMsgTimeThreshold),
        ...minRxWindowEuBinary(userSettings.minRxWindowEu),
        ...minRxWindowUsBinary(userSettings.minRxWindowUs),
        ...timezoneOffsetBinary(userSettings.timeZoneOffset),
        ...ntpServerBinary(userSettings.ntpServer),
        ...hwDiscoverBinary(),
        ...logEnableBinary(userSettings.logEnable),
        ...echo_resistance_typeBinary(),
        ...gateway_portBinary(userSettings.gateway_port),
        ...settingsVerBinary(),
        ...(userSettings.fwVersion === "FW>=201" ? anyDnsBinary(userSettings.primaryDns) : []),
        ...(userSettings.fwVersion === "FW>=201" ? anyDnsBinary(userSettings.secondaryDns) : []),
        ...(userSettings.fwVersion === "FW>=201" ? uplinkURLBinary(userSettings.uplinkUrl) : []),
        ...magicBinary(),
    ])
    memoryMap.set(0x08080000, binarySettings);  // 0x08080000 is the starting address - important for the first row in hex

    let string = memoryMap.asHexString(32);

    console.log(string)
    return string
}

/**
 * cuts binary number (as string) to 8 bits parts and converts these parts to decimal elements of Uint8Array
 * starts from the end because of LITTLE ENDIAN
 * @param binaryString
 * @returns Uint8Array
 */
function convertBinaryNumberToUint8Array(binaryString) {
    //check
    if (binaryString.length % 8 !== 0) {
        console.log("Wrong length of binary string");
        return null;
    }

    let result = new Uint8Array([]);
    for (let i = binaryString.length; i > 0; i-=8){
        result = [...result, parseInt(binaryString.substr(i - 8, 8), 2)]
    }
    return result;
}

/**
 * converts string to ASCII codes and returns Uint8Array of them. Also adds padding to the end of the string
 * @param string - string to conver
 * @param expectedLength number of hexa numbers (one hexa number is one element of Uint8Array) reserved for the string in hex file
 */
function convertStringToUint8Array(string, expectedLength) {
    let result = new Uint8Array([]);
    for (let i = 0; i<string.length; i++) {
        result = [...result, string.charCodeAt(i)]
    }

    //add padding
    if (result.length < expectedLength) {
        let number_of_missing = expectedLength - result.length;
        for (let i = 0; i<number_of_missing; i++) {
            result = [...result, 0]
        }
    }
    return result
}

/**
 * default STANDALONE
 * @returns {Uint8Array}
 */
function sensRoleBinary() {
    return new Uint8Array([2])
}

function measTimesBinary(measTimes) {
    let measTimesNumbers = measTimes.map(function(item) {
        return parseInt(item, 10);
    })
    let binaryString = "00000000";
    for (let i = 23; i > 0; i--) {
        if (measTimesNumbers.includes(i)) {
            binaryString += "1";
        }
        else {
            binaryString += "0";
        }
    }
    // hour 24 is the last bit
    if (measTimesNumbers.includes(24)) {
        binaryString += "1"
    }
    else {
        binaryString += "0"
    }
    return convertBinaryNumberToUint8Array(binaryString);
}

function measIntervalBinary(measInterval) {
    let measIntervalBinaryString = Number(measInterval).toString(2);
    measIntervalBinaryString = measIntervalBinaryString.padStart(32, "0");
    return convertBinaryNumberToUint8Array(measIntervalBinaryString);
}


function measTypeBinary(measType) {
    let typeInt = 0;
    if (measType === "off") typeInt = 0;
    if (measType === "schedule") typeInt = 1;
    if (measType === "interval") typeInt = 2;

    return new Uint8Array([typeInt]);
}

function temp_thresholdBinary(temp) {
    return new Uint8Array([temp]);
}

/**
 * unused, default 5
 */
function scan_intervalBinary() {
    return new Uint8Array([5]);
}

/**
 * internal use, sensor active or inactive
 * default 0
 * @returns {Uint8Array}
 */
function magnetOnBinary() {
    return new Uint8Array([0])
}

/**
 * enum
 * ACC_NONE_COLLECTION = 0x00,
 * ACC_SIDE_COLLECTION = 0x01,
 * ACC_VERTICAL_COLLECTION = 0x02,
 * @param accDetectType
 */
function accDetectTypeBinary(accDetectType) {
    if (accDetectType === "none") return new Uint8Array([0]);
    if (accDetectType === "side") return new Uint8Array([1]);
    if (accDetectType === "vertical") return new Uint8Array([2]);
}

function accSensitivityBinary(accSensitivity) {
    return new Uint8Array([parseInt(accSensitivity, 10)])
}

function accMovementBinary(accMovement) {
    return new Uint8Array([parseInt(accMovement, 10)])
}

/**
 *
 typedef enum {
	TX_RADIO_NONE = 0x00,
	TX_RADIO_LORA,
	TX_RADIO_SIGFOX,
	TX_RADIO_GSM,
	TX_RADIO_NBIOT,
	TX_RADIO_GPRS,
	TX_RADIO_CATM1
} tx_radio_t;
 * @param tx_radio
 */
function tx_radioBinary(tx_radio) {
    if (tx_radio === "none") return new Uint8Array([0]);
    if (tx_radio === "lora") return new Uint8Array([1]);
    if (tx_radio === "sigfox") return new Uint8Array([2]);
    // if (tx_radio === "gsm") return new Uint8Array([3]);
    if (tx_radio === "nbiot") return new Uint8Array([4]);
    // if (tx_radio === "gprs") return new Uint8Array([5]);
    // if (tx_radio === "catm1") return new Uint8Array([6]);
}

/**
 * ABP - 0
 * OTAA - 1
 * @param otaa
 */
function otaaBinary(otaa) {
    if (otaa === "otaa") return new Uint8Array([1])
    if (otaa === "abp") return new Uint8Array([0])

}

/**
 * 0 (AS923) (subbands)
 * 1 (AU915) (subbands)
 * 5 (EU868)
 * 7 (IN868)
 * 9 (US915) (subbands)
 * 10 (IL915)
 * @param loraRegion
 */
function loraRegionBinary(loraRegion) {
    if (loraRegion === "AS923") return new Uint8Array([0])
    if (loraRegion === "AU915") return new Uint8Array([1])
    if (loraRegion === "EU868") return new Uint8Array([5])
    if (loraRegion === "IN868") return new Uint8Array([7])
    if (loraRegion === "US915") return new Uint8Array([9])
    if (loraRegion === "IL915") return new Uint8Array([10])
}

/**
 * US915: 0x0 - 0x8
 * AU915: 0x0 - 0x8
 * AS923: 0x1 - 0x4
 * other regions: unused (default 2)
 * @param loraSubband
 * @param loraRegion
 */
function loraSubbandBinary(loraSubband, loraRegion) {
    if (["US915", "AU915", "AS923"].includes(loraRegion)) {
        return new Uint8Array([parseInt(loraSubband, 10)])
    }
    else return new Uint8Array([2])     //default value
}

/**
 * deprecated, default value 000000
 * @returns {Uint8Array}
 */
function tilt_axisBinary() {
    return new Uint8Array([0, 0, 0])
}

function gatewayIPBinary(gatewayIP) {
    return convertStringToUint8Array(gatewayIP, 18)
}

function NBIOT_operatorBinary(nbiot_operator) {
    return convertStringToUint8Array(nbiot_operator, 65)
}

function nbiot_apnBinary(nbiot_apn) {
    return convertStringToUint8Array(nbiot_apn, 65)
}

function ntpServerBinary(ntpServer) {
    return convertStringToUint8Array(ntpServer, 32)
}

/**
 * unused
 * 16 * uint32 = 16 * 4B = 64 Uint8
 */
function slaves_addrBinary() {
    let result = new Uint8Array([]);
    for (let i = 0; i < 64; i+=1){
        result = [...result, 0]
    }
    return result;
}

/**
 * unused
 * us_calibrated_threshold[2], typ uint16
 * 2*uint16 = 4*uint8 = 4 hexa dvojice
 */
function us_calibrated_thresholdBinary() {
    return new Uint8Array([0, 0, 0, 0])
}

/**
 * time in seconds - uint32
 * @param loraConfirmedTime
 * @returns {Uint8Array}
 */
function loraConfirmedMsgTimeThresholdBinary(loraConfirmedTime) {
    let loraConfirmedTimeBinaryString = Number(loraConfirmedTime).toString(2);
    loraConfirmedTimeBinaryString = loraConfirmedTimeBinaryString.padStart(32, "0");
    return convertBinaryNumberToUint8Array(loraConfirmedTimeBinaryString);
}

function minRxWindowEuBinary(minRxWindowEu) {
    return new Uint8Array([minRxWindowEu])
}

function minRxWindowUsBinary(minRxWindowUs) {
    return new Uint8Array([minRxWindowUs])
}

/**
 * time_t - uint_32
 * @param timezoneOffset
 */
function timezoneOffsetBinary(timezoneOffset) {
    let timeZoneOffsetBinaryString = Number(timezoneOffset).toString(2);
    timeZoneOffsetBinaryString = timeZoneOffsetBinaryString.padStart(32, "0");
    return convertBinaryNumberToUint8Array(timeZoneOffsetBinaryString);
}

function hwDiscoverBinary() {
    return new Uint8Array([0])
}

function logEnableBinary(logEnable) {
   return new Uint8Array([logEnable])

}

/**
 * default value 00
 */
function echo_resistance_typeBinary() {
    return new Uint8Array([0])
}

/**
 * uint_16
 * @param gateway_port
 * @returns {Uint8Array}
 */
function gateway_portBinary(gateway_port) {
    let gatewayPortBinaryString = Number(gateway_port).toString(2);
    gatewayPortBinaryString = gatewayPortBinaryString.padStart(16, "0");
    return convertBinaryNumberToUint8Array(gatewayPortBinaryString);
}

/**
 * converts any DNS to Uint8Array
 * @param {string} dns - should contain 4 numbers separated by dots 
 * @returns 
 */
function anyDnsBinary(dns) {
    const ipNumbers = dns.split(".");
    if (ipNumbers.length !== 4) {
        throw new Error("Wrong primary DNS format, should be x.x.x.x");
    }
    
    const uintArray = new Uint8Array([ipNumbers[0], ipNumbers[1], ipNumbers[2], ipNumbers[3]]);

    return uintArray;
}

function uplinkURLBinary(uplinkURL) {
    return convertStringToUint8Array(uplinkURL, 65)
}

/**
 * internal use,
 * default 0xACE5E7 - little endian E7 E5 AC
 * TODO check
 */
function magicBinary() {
    return new Uint8Array([231, 229, 172, 0])
}

/**
 * internal use
 * default 1
 * TODO check
 */
function settingsVerBinary() {
    return new Uint8Array([1, 0])
}







